// Calculator

document.addEventListener("DOMContentLoaded", function () {
  const openCalculatorButton = document.querySelector(".open-calculator");
  const openCalculatorHeader = document.querySelector(".cal-culator-header");
  const calculatorDiv = document.querySelector(".calculator-lp");
  const overlayCalculator = document.querySelector(".overlay-calculator");
  const closeCalculatorBtn = document.querySelector(
    ".close-calculator-shop-now"
  );
  const closeCalculatorSvg = document.querySelector(".close-calculator");
  const resultWrapper = document.querySelector(".cat-culator-result");
  const resultContainer = document.querySelector(".cat-culator-result-img");
  const calculatorWrapper = document.querySelector(".cat-culator-wrp");

  openCalculatorButton.addEventListener("click", function () {
    calculatorDiv.classList.remove("tw-hidden");
    calculatorDiv.classList.add("!tw-flex");
    calculatorDiv.classList.add("calculator-lp-wrapper");
  });

  openCalculatorHeader.addEventListener("click", function () {
    overlayCalculator.classList.remove("tw-hidden");
    calculatorDiv.classList.remove("tw-hidden");
    calculatorDiv.classList.add("!tw-flex");
    calculatorDiv.classList.add("calculator-lp-wrapper");
  });

  closeCalculatorBtn.addEventListener("click", function () {
    calculatorDiv.classList.add("tw-hidden");
    overlayCalculator.classList.add("tw-hidden");
    calculatorDiv.classList.remove("!tw-flex");
    calculatorDiv.classList.remove("calculator-lp-wrapper");
    resultContainer.classList.remove("has-result");
    resultWrapper.classList.remove("has-result-wrapper");
    calculatorWrapper.classList.remove("best-option-show");
    closeCalculatorBtn.style.display = "none";

    const productSection = document.querySelector("#product-section");
    if (productSection) {
      productSection.scrollIntoView({ behavior: "smooth" });
    }
  });

  closeCalculatorSvg.addEventListener("click", function () {
    overlayCalculator.classList.add("tw-hidden");
    calculatorDiv.classList.add("tw-hidden");
    calculatorDiv.classList.remove("!tw-flex");
    calculatorDiv.classList.remove("calculator-lp-wrapper");
    resultContainer.classList.remove("has-result");
    resultWrapper.classList.remove("has-result-wrapper");
    calculatorWrapper.classList.remove("best-option-show");

    const productSection = document.querySelector("#product-section");
    if (productSection) {
      productSection.scrollIntoView({ behavior: "smooth" });
    }
  });
});

// Owl Carousel

$(document).ready(function () {
  $(".product-features--slider").owlCarousel({
    stagePadding: 50,
    loop: true,
    margin: 50,
    nav: false,
    autoplay: true,
    slideTransition: "linear",
    autoplayTimeout: 3000,
    autoplaySpeed: 3000,
    autoplayHoverPause: false,
    items: 2,
    mouseDrag: false,
    touchDrag: false,
    responsive: {
      0: {
        items: 1,
        stagePadding: 50,
      },
      1024: {
        items: 3,
        stagePadding: 50,
      },
    },
  });
});

$(document).ready(function () {
  $(".reviews--manual-container").owlCarousel({
    items: 1,
    loop: true,
    margin: 10,
    nav: false,
    dots: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
    mouseDrag: false,
    touchDrag: false,
  });

  $(".custom-prev").click(function () {
    $(".reviews--manual-container").trigger("prev.owl.carousel");
  });

  $(".custom-next").click(function () {
    $(".reviews--manual-container").trigger("next.owl.carousel");
  });
});

$(document).ready(function () {
  $(".product-benefits--slider").owlCarousel({
    stagePadding: 50,
    loop: true,
    margin: 50,
    nav: false,
    autoplay: true,
    slideTransition: "linear",
    autoplayTimeout: 3000,
    autoplaySpeed: 3000,
    autoplayHoverPause: false,
    mouseDrag: false,
    touchDrag: false,
    items: 2,
    responsive: {
      0: {
        items: 1,
        stagePadding: 20,
      },
      600: {
        items: 1,
        stagePadding: 0,
      },
      1000: {
        items: 3,
        stagePadding: 0,
      },
    },
  });
});

$(document).ready(function () {
  $(".static--testimonal").owlCarousel({
    loop: true,
    center: false,
    nav: true,
    margin: 10,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="14" viewBox="0 0 35 14" fill="none"><path d="M7.75397 6.26894C7.79423 6.26894 7.83412 6.26894 7.87438 6.26894C12.1761 6.26089 16.4778 6.25284 20.7796 6.24515C23.1059 6.24112 25.4327 6.23637 27.759 6.23417C29.6348 6.23234 31.5106 6.2349 33.3865 6.2338C33.5358 6.2338 33.6844 6.22612 33.8315 6.26162C34.0504 6.31433 34.2426 6.41315 34.3945 6.58188C34.6551 6.8714 34.6792 7.26632 34.4519 7.58256C34.2711 7.83437 34.016 7.9665 33.7159 8.01555C33.624 8.03055 33.5296 8.03019 33.4362 8.03385C33.3718 8.03641 33.3074 8.03348 33.243 8.03348C31.4814 8.03348 29.7198 8.03787 27.9578 8.03238C26.0706 8.02653 24.1835 8.00969 22.2963 8.00164C19.8177 7.99102 17.3391 7.9848 14.8604 7.97602C12.3437 7.96687 9.82705 7.95698 7.31036 7.94783C7.28437 7.94783 7.25875 7.94783 7.22727 7.96138C7.2485 7.97272 7.26863 7.98553 7.29059 7.99468C8.60897 8.54809 9.82998 9.26913 10.9642 10.1377C11.4437 10.5048 11.8968 10.9015 12.3086 11.3441C12.5366 11.5893 12.739 11.8539 12.9239 12.1317C13.0897 12.381 13.1446 12.6529 13.0414 12.9421C12.9026 13.3308 12.5297 13.4669 12.238 13.4373C12.0422 13.4175 11.8742 13.3333 11.7157 13.225C11.6944 13.2103 11.6772 13.1891 11.6597 13.1697C10.133 11.508 8.33299 10.2215 6.29358 9.26474C5.28156 8.79003 4.23147 8.42365 3.1382 8.18428C2.61187 8.06898 2.08079 7.98444 1.54312 7.94491C1.40477 7.93466 1.27081 7.90757 1.14819 7.84096C0.857216 7.68211 0.698002 7.43542 0.68446 7.10564C0.668354 6.71548 0.954941 6.37033 1.34145 6.29895C1.39562 6.28907 1.45162 6.27919 1.50615 6.28102C2.01967 6.29603 2.52 6.20635 3.01632 6.08886C3.55692 5.96113 4.09532 5.82497 4.61981 5.63794C5.40417 5.35831 6.15267 5.00035 6.88725 4.61128C8.03433 4.00406 9.14115 3.33207 10.1821 2.55539C10.5715 2.26478 10.9496 1.95953 11.2988 1.6206C11.4163 1.50677 11.5253 1.38416 11.6355 1.26337C11.8848 0.990329 12.1878 0.880525 12.5461 0.984472C13.0908 1.14222 13.2796 1.79738 12.9176 2.24941C12.8682 2.3109 12.8148 2.36946 12.7599 2.42582C11.4931 3.7237 10.0939 4.85833 8.55004 5.81106C8.3092 5.95966 8.05336 6.08447 7.80411 6.22026C7.78654 6.22978 7.76897 6.23893 7.75177 6.24808L7.75433 6.26894H7.75397Z" fill="white"/></svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="35" height="14" viewBox="0 0 35 14" fill="none"><path d="M27.246 8.11827C27.2058 8.11827 27.1659 8.11827 27.1256 8.11827C22.8239 8.12632 18.5222 8.13437 14.2204 8.14206C11.8941 8.14608 9.56733 8.15084 7.24097 8.15304C5.36516 8.15487 3.48935 8.15231 1.61354 8.1534C1.46421 8.1534 1.31561 8.16109 1.16847 8.12559C0.949599 8.07288 0.757443 7.97406 0.605549 7.80533C0.344949 7.51581 0.320792 7.12089 0.548085 6.80465C0.728895 6.55284 0.984004 6.42071 1.28413 6.37166C1.376 6.35665 1.47043 6.35702 1.56377 6.35336C1.62818 6.3508 1.6926 6.35373 1.75702 6.35373C3.51863 6.35373 5.28024 6.34933 7.04222 6.35482C8.92937 6.36068 10.8165 6.37752 12.7037 6.38557C15.1823 6.39618 17.6609 6.40241 20.1396 6.41119C22.6563 6.42034 25.1729 6.43022 27.6896 6.43937C27.7156 6.43937 27.7412 6.43937 27.7727 6.42583C27.7515 6.41448 27.7314 6.40167 27.7094 6.39252C26.391 5.83911 25.17 5.11807 24.0358 4.24953C23.5563 3.88242 23.1032 3.48566 22.6914 3.04315C22.4634 2.79793 22.261 2.5333 22.0761 2.2555C21.9103 2.00625 21.8554 1.7343 21.9586 1.44515C22.0974 1.05645 22.4703 0.92029 22.762 0.949937C22.9578 0.969701 23.1258 1.05388 23.2843 1.16222C23.3056 1.17686 23.3228 1.19809 23.3403 1.21749C24.867 2.87918 26.667 4.16571 28.7064 5.12247C29.7184 5.59718 30.7685 5.96356 31.8618 6.20293C32.3881 6.31822 32.9192 6.40277 33.4569 6.4423C33.5952 6.45255 33.7292 6.47963 33.8518 6.54625C34.1428 6.7051 34.302 6.95179 34.3155 7.28156C34.3316 7.67173 34.0451 8.01688 33.6586 8.08825C33.6044 8.09814 33.5484 8.10802 33.4938 8.10619C32.9803 8.09118 32.48 8.18085 31.9837 8.29834C31.4431 8.42608 30.9047 8.56224 30.3802 8.74927C29.5958 9.0289 28.8473 9.38686 28.1127 9.77593C26.9657 10.3831 25.8589 11.0551 24.8179 11.8318C24.4285 12.1224 24.0504 12.4277 23.7012 12.7666C23.5837 12.8804 23.4747 13.0031 23.3645 13.1238C23.1152 13.3969 22.8122 13.5067 22.4539 13.4027C21.9092 13.245 21.7204 12.5898 22.0824 12.1378C22.1318 12.0763 22.1852 12.0177 22.2401 11.9614C23.5069 10.6635 24.9061 9.52887 26.45 8.57615C26.6908 8.42755 26.9466 8.30274 27.1959 8.16694C27.2135 8.15743 27.231 8.14828 27.2482 8.13913L27.2457 8.11827H27.246Z" fill="white"/></svg>',
    ],
    responsive: {
      0: {
        items: 1,
        margin: 40,
        stagePadding: 20,
      },
      600: {
        items: 1,
        margin: 40,
        stagePadding: 100,
      },
      1000: {
        items: 3,
        stagePadding: 0,
      },
    },
  });
});

// Content Modal

document.addEventListener("DOMContentLoaded", function () {
  const openModalButtons = document.querySelectorAll(".open-modal");

  openModalButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      const modalId = this.dataset.modal;
      const modal = document.getElementById(modalId);

      if (modal) {
        modal.style.display = "block";

        const closeModal = function () {
          modal.style.display = "none";
          window.removeEventListener("click", outsideClick);
          closeModalButton.removeEventListener("click", closeModal);
        };

        const outsideClick = function (event) {
          if (event.target === modal) {
            closeModal();
          }
        };

        const closeModalButton = modal.querySelector(".close-read-more");

        if (closeModalButton) {
          closeModalButton.addEventListener("click", closeModal);
        }

        window.addEventListener("click", outsideClick);
      } else {
        console.error("Modal not found: ", modalId);
      }
    });
  });
});

// Tab Switcher

document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab--alternate li");
  const containers = {
    "real-results": document.querySelector(".real-results-container"),
    subscriptions: document.querySelector(".subscriptions-container"),
    upcycling: document.querySelector(".upcycling-container"),
  };

  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      Object.values(containers).forEach((container) => {
        container.classList.add("tw-hidden");
        container.classList.remove("activated-sm");
      });

      const targetClass = this.classList[0];
      const targetContainer = containers[targetClass];

      if (targetContainer) {
        targetContainer.classList.remove("tw-hidden");
        targetContainer.classList.add("activated-sm");
      }

      tabs.forEach((item) => item.classList.remove("tab-activated"));
      this.classList.add("tab-activated");
    });
  });
  const initialTab = document.querySelector(".real-results");
  const initialContainer = containers["real-results"];

  if (initialTab && initialContainer) {
    initialTab.classList.add("tab-activated");
    initialContainer.classList.add("activated-sm");
    initialContainer.classList.remove("tw-hidden");
  }
});

// Testimonials Tab Switcher

document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".testimonials-list li");
  const containers = {
    "cat-health": document.querySelector(".cat-health-container"),
    "performance": document.querySelector(".performance-container"),
    "sustainability": document.querySelector(".sustainability-container"),
  };

  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      const targetClass = this.dataset.target; // Obtém o valor de data-target

      if (containers[targetClass]) {
        // Esconde todas as containers
        Object.values(containers).forEach((container) => {
          container.classList.add("tw-hidden");
          container.classList.remove("tw-grid");
        });

        // Mostra o container correspondente
        containers[targetClass].classList.remove("tw-hidden");
        containers[targetClass].classList.add("tw-grid");

        // Atualiza as tabs
        tabs.forEach((item) => item.classList.remove("tab-activated"));
        this.classList.add("tab-activated");
      }
    });
  });
});


// Open Paw Video

document.getElementById("paw-video-one").addEventListener("click", function () {
  document.querySelector(".paw-video-one-container").classList.add("!tw-flex");
});

document
  .querySelector(".close-video-one")
  .addEventListener("click", function () {
    document
      .querySelector(".paw-video-one-container")
      .classList.remove("!tw-flex");
    var videoOne = document.getElementById("video-one");
    videoOne.pause();
  });

document.getElementById("paw-video-two").addEventListener("click", function () {
  document.querySelector(".paw-video-two-container").classList.add("!tw-flex");
});

document
  .querySelector(".close-video-two")
  .addEventListener("click", function () {
    document
      .querySelector(".paw-video-two-container")
      .classList.remove("!tw-flex");
    var videoTwo = document.getElementById("video-two");
    videoTwo.pause();
  });

document
  .getElementById("paw-video-three")
  .addEventListener("click", function () {
    document
      .querySelector(".paw-video-three-container")
      .classList.add("!tw-flex");
  });

document
  .querySelector(".close-video-three")
  .addEventListener("click", function () {
    document
      .querySelector(".paw-video-three-container")
      .classList.remove("!tw-flex");
    var videoThree = document.getElementById("video-three");
    videoThree.pause();
  });

document
  .getElementById("paw-video-four")
  .addEventListener("click", function () {
    document
      .querySelector(".paw-video-four-container")
      .classList.add("!tw-flex");
  });

document
  .querySelector(".close-video-four")
  .addEventListener("click", function () {
    document
      .querySelector(".paw-video-four-container")
      .classList.remove("!tw-flex");
    var videoFour = document.getElementById("video-four");
    videoFour.pause();
  });

document
  .getElementById("paw-video-five")
  .addEventListener("click", function () {
    document
      .querySelector(".paw-video-five-container")
      .classList.add("!tw-flex");
  });

document
  .querySelector(".close-video-five")
  .addEventListener("click", function () {
    document
      .querySelector(".paw-video-five-container")
      .classList.remove("!tw-flex");
    var videoFive = document.getElementById("video-five");
    videoFive.pause();
  });

document.addEventListener("DOMContentLoaded", function () {
  const faqContainers = document.querySelectorAll(".faq--container");

  function hideAllAnswers() {
    faqContainers.forEach(function (container) {
      const answer = container.querySelector(".faq--answer");
      const arrowUp = container.querySelector(".faq--arrow-up");
      const arrowDown = container.querySelector(".faq--arrow-down");
      answer.classList.add("tw-hidden");
      answer.classList.remove("tw-flex");
      arrowUp.classList.add("tw-hidden");
      arrowDown.classList.remove("tw-hidden");
    });
  }

  hideAllAnswers();
  const firstFaq = faqContainers[0];
  const firstAnswer = firstFaq.querySelector(".faq--answer");
  const firstArrowUp = firstFaq.querySelector(".faq--arrow-up");
  const firstArrowDown = firstFaq.querySelector(".faq--arrow-down");
  firstAnswer.classList.remove("tw-hidden");
  firstAnswer.classList.add("tw-flex");
  firstArrowUp.classList.remove("tw-hidden");
  firstArrowDown.classList.add("tw-hidden");
  faqContainers.forEach(function (container) {
    const titleContainer = container.querySelector(".faq-title--container");
    titleContainer.addEventListener("click", function () {
      hideAllAnswers();

      const answer = container.querySelector(".faq--answer");
      const arrowUp = container.querySelector(".faq--arrow-up");
      const arrowDown = container.querySelector(".faq--arrow-down");
      answer.classList.remove("tw-hidden");
      answer.classList.add("tw-flex");
      arrowUp.classList.remove("tw-hidden");
      arrowDown.classList.add("tw-hidden");
    });
  });
});